"use client";

import { useState, useEffect } from "react";
import { ArrowRightIcon } from "@/utils/icons"; 

export default function ScrollToTopButton() {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const SCROLL_THRESHOLD = 300; 

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    if (window.scrollY > SCROLL_THRESHOLD) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!showScrollToTop) {
    return null;
  }

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 p-3 rounded-full bg-primary-600 text-white shadow-lg 
                 hover:bg-primary-700 transition-colors duration-300 transform hover:scale-110 
                 focus:outline-none focus:ring-4 focus:ring-primary-400 focus:ring-opacity-50"
      aria-label="Scroll to top of page"
      title="Scroll to Top"
    >
      <ArrowRightIcon className="h-5 w-5 transform rotate-[-90deg]" />
    </button>
  );
}